import React from "react";
import {
  FiSearch,
  FiChevronDown,
  FiMoreVertical,
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";
import {
  HiOutlineCheckCircle,
  HiOutlineClock,
  HiOutlineExclamationCircle,
} from "react-icons/hi2";

export default function TrainingComplianceTable() {
  const staffData = [
    {
      initials: "AR",
      name: "Ahmed Raza",
      role: "Head Chef",
      foodSafety: { status: "success", label: "Level 2", date: "12 Apr 2026" },
      allergens: { status: "success", date: "12 Apr 2026" },
      healthSafety: { status: "success", date: "05 Mar 2026" },
      fireSafety: { status: "success", date: "05 Mar 2026" },
      otherTraining: {
        title: "Knife Skills",
        date: "20 Apr 2026",
        status: "success",
      },
      overallStatus: "Up to date",
    },
    {
      initials: "SK",
      name: "Sara Khan",
      role: "Server",
      foodSafety: { status: "success", label: "Level 2", date: "18 Apr 2026" },
      allergens: { status: "success", date: "18 Apr 2026" },
      healthSafety: { status: "success", date: "10 Mar 2026" },
      fireSafety: { status: "success", date: "10 Mar 2026" },
      otherTraining: { title: "N/A", date: "—", status: "none" },
      overallStatus: "Up to date",
    },
    {
      initials: "JS",
      name: "John Smith",
      role: "Kitchen Assistant",
      foodSafety: { status: "success", label: "Level 2", date: "20 Apr 2026" },
      allergens: { status: "warning", label: "Due", date: "22 May 2026" },
      healthSafety: { status: "success", date: "15 Mar 2026" },
      fireSafety: { status: "success", date: "15 Mar 2026" },
      otherTraining: {
        title: "Food Prep",
        date: "30 May 2026",
        status: "warning",
      },
      overallStatus: "Due soon",
    },
    {
      initials: "EM",
      name: "Emily White",
      role: "Server",
      foodSafety: { status: "warning", label: "Due", date: "25 May 2026" },
      allergens: { status: "success", date: "10 Apr 2026" },
      healthSafety: { status: "success", date: "02 Mar 2026" },
      fireSafety: { status: "success", date: "02 Mar 2026" },
      otherTraining: { title: "N/A", date: "—", status: "none" },
      overallStatus: "Due soon",
    },
    {
      initials: "UA",
      name: "Usman Ali",
      role: "Manager",
      foodSafety: { status: "success", label: "Level 3", date: "15 Apr 2026" },
      allergens: { status: "success", date: "15 Apr 2026" },
      healthSafety: { status: "success", date: "05 Mar 2026" },
      fireSafety: { status: "success", date: "05 Mar 2026" },
      otherTraining: { title: "HACCP", date: "12 Apr 2026", status: "success" },
      overallStatus: "Up to date",
    },
    {
      initials: "ZB",
      name: "Zainab Butt",
      role: "Cleaner",
      foodSafety: { status: "none", label: "N/A", date: "—" },
      allergens: { status: "success", date: "15 Apr 2026" },
      healthSafety: { status: "success", date: "15 Mar 2026" },
      fireSafety: { status: "success", date: "15 Mar 2026" },
      otherTraining: {
        title: "Chemical Safety",
        date: "30 May 2026",
        status: "warning",
      },
      overallStatus: "Due soon",
    },
    {
      initials: "MT",
      name: "Mohammad Tariq",
      role: "Kitchen Porter",
      foodSafety: { status: "danger", label: "Due", date: "10 May 2026" },
      allergens: { status: "danger", label: "Overdue", date: "8 May 2026" },
      healthSafety: { status: "success", date: "10 Mar 2026" },
      fireSafety: { status: "success", date: "10 Mar 2026" },
      otherTraining: { title: "N/A", date: "—", status: "none" },
      overallStatus: "Overdue",
    },
    {
      initials: "LR",
      name: "Laura Roberts",
      role: "Barista",
      foodSafety: { status: "success", label: "Level 3", date: "22 Apr 2026" },
      allergens: { status: "success", date: "22 Apr 2026" },
      healthSafety: { status: "success", date: "12 Mar 2026" },
      fireSafety: { status: "success", date: "12 Mar 2026" },
      otherTraining: {
        title: "Barista Training",
        date: "18 May 2026",
        status: "warning",
      },
      overallStatus: "Due soon",
    },
  ];

  // Helper component to render specific cell configurations cleanly
  const TrainingCell = ({ data }) => {
    if (!data || data.status === "none") {
      return (
        <div className="flex flex-col text-left">
          <span className="text-xs font-semibold text-slate-400">
            {data?.label || "N/A"}
          </span>
          <span className="text-[10px] text-slate-400">—</span>
        </div>
      );
    }

    return (
      <div className="flex items-start gap-2 text-left">
        <div className="mt-0.5 shrink-0">
          {data.status === "success" && (
            <HiOutlineCheckCircle className="w-4 h-4 text-emerald-600" />
          )}
          {data.status === "warning" && (
            <HiOutlineClock className="w-4 h-4 text-amber-500" />
          )}
          {data.status === "danger" && (
            <HiOutlineExclamationCircle className="w-4 h-4 text-rose-600" />
          )}
        </div>
        <div className="flex flex-col min-w-0">
          <span
            className={`text-xs font-semibold ${data.status === "danger" ? "text-rose-600" : data.status === "warning" ? "text-amber-600" : "text-slate-700"} truncate`}
          >
            {data.title || data.label || (data.status === "success" && "")}
          </span>
          <span className="text-[10px] text-slate-400 font-medium whitespace-nowrap">
            {data.date}
          </span>
        </div>
      </div>
    );
  };

  // Helper to resolve styles for the master "Overall Status" badge block
  const getOverallStatusStyles = (status) => {
    switch (status) {
      case "Up to date":
        return "bg-emerald-50 text-emerald-700 border border-emerald-100";
      case "Due soon":
        return "bg-amber-50 text-amber-700 border border-amber-100";
      case "Overdue":
        return "bg-rose-50 text-rose-700 border border-rose-100";
      default:
        return "bg-slate-50 text-slate-600";
    }
  };

  return (
    <div className="w-full bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden font-sans">
      {/* Top Header Filter Control Area */}
      <div className="p-5 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between border-b border-slate-100">
        <div>
          <h2 className="text-lg font-bold text-slate-900 tracking-tight">
            Training Compliance by Staff
          </h2>
          <p className="text-xs text-slate-500 mt-0.5">
            Shows training required for each person's role and their current
            status.
          </p>
        </div>

        {/* Input Controls Container Row */}
        <div className="flex flex-wrap items-center gap-3">
          <div className="relative">
            <select className="appearance-none bg-white border border-slate-200 rounded-lg pl-3 pr-8 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50 focus:outline-none min-w-[110px]">
              <option>All Roles</option>
            </select>
            <FiChevronDown className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
          </div>

          <div className="relative">
            <select className="appearance-none bg-white border border-slate-200 rounded-lg pl-3 pr-8 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50 focus:outline-none min-w-[120px]">
              <option>All Statuses</option>
            </select>
            <FiChevronDown className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
          </div>

          <div className="relative min-w-[180px]">
            <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 w-3.5 h-3.5" />
            <input
              type="text"
              placeholder="Search staff..."
              className="w-full pl-9 pr-3 py-1.5 bg-white border border-slate-200 rounded-lg text-xs placeholder-slate-400 text-slate-700 focus:outline-none focus:border-blue-500"
            />
          </div>
        </div>
      </div>

      {/* Responsive Horizontal Scroll wrapper */}
      <div className="w-full overflow-x-auto">
        <table className="w-full border-collapse text-left min-w-[1000px]">
          <thead>
            <tr className="border-b border-slate-100 bg-slate-50/50">
              <th className="py-3 px-4 text-xs font-semibold text-slate-500 tracking-wide w-[200px]">
                Staff Member
              </th>
              <th className="py-3 px-4 text-xs font-semibold text-slate-500 tracking-wide w-[130px]">
                Role
              </th>
              <th className="py-3 px-4 text-xs font-semibold text-slate-500 tracking-wide">
                Food Safety
              </th>
              <th className="py-3 px-4 text-xs font-semibold text-slate-500 tracking-wide">
                Allergens
              </th>
              <th className="py-3 px-4 text-xs font-semibold text-slate-500 tracking-wide">
                Health & Safety Induction
              </th>
              <th className="py-3 px-4 text-xs font-semibold text-slate-500 tracking-wide">
                Fire Safety
              </th>
              <th className="py-3 px-4 text-xs font-semibold text-slate-500 tracking-wide">
                Other Role Training
              </th>
              <th className="py-3 px-4 text-xs font-semibold text-slate-500 tracking-wide text-center w-[110px]">
                Overall Status
              </th>
              <th className="py-3 px-4 text-xs font-semibold text-slate-500 tracking-wide text-center w-[60px]">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {staffData.map((row, index) => (
              <tr
                key={index}
                className="hover:bg-slate-50/50 transition-colors"
              >
                {/* Profile Circle and User Title Meta column */}
                <td className="py-3.5 px-4">
                  <div className="flex items-center gap-3">
                    <div className="w-7 h-7 bg-slate-100 rounded-full flex items-center justify-center shrink-0">
                      <span className="text-[10px] font-bold text-slate-500 tracking-wider">
                        {row.initials}
                      </span>
                    </div>
                    <span className="text-xs font-bold text-slate-800 whitespace-nowrap">
                      {row.name}
                    </span>
                  </div>
                </td>

                {/* Role Description column */}
                <td className="py-3.5 px-4">
                  <span className="text-xs font-medium text-slate-600 whitespace-nowrap">
                    {row.role}
                  </span>
                </td>

                {/* Individual Module Columns map implementation */}
                <td className="py-3.5 px-4">
                  <TrainingCell data={row.foodSafety} />
                </td>
                <td className="py-3.5 px-4">
                  <TrainingCell data={row.allergens} />
                </td>
                <td className="py-3.5 px-4">
                  <TrainingCell data={row.healthSafety} />
                </td>
                <td className="py-3.5 px-4">
                  <TrainingCell data={row.fireSafety} />
                </td>
                <td className="py-3.5 px-4">
                  <TrainingCell data={row.otherTraining} />
                </td>

                {/* Status indicator module mapping placement block */}
                <td className="py-3.5 px-4 text-center">
                  <span
                    className={`inline-block px-2.5 py-0.5 text-[10px] font-semibold rounded-full whitespace-nowrap capitalize ${getOverallStatusStyles(row.overallStatus)}`}
                  >
                    {row.overallStatus}
                  </span>
                </td>

                {/* Dynamic Context Menu Node Trigger button icon */}
                <td className="py-3.5 px-4 text-center">
                  <button className="text-slate-400 hover:text-slate-600 p-1 rounded transition">
                    <FiMoreVertical className="w-4 h-4 mx-auto" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Footer Navigation Bar Markup Layout block area */}
      <div className="px-5 py-3.5 bg-white border-t border-slate-100 flex items-center justify-between">
        <span className="text-xs font-medium text-slate-500">
          Showing 1 to 8 of 12 staff
        </span>

        {/* Pagination Action Triggers menu wrapper block */}
        <div className="flex items-center gap-1.5">
          <button className="p-1.5 border border-slate-200 rounded-lg text-slate-400 bg-white hover:bg-slate-50 disabled:opacity-50 transition">
            <FiChevronLeft className="w-4 h-4" />
          </button>

          <button className="w-7 h-7 flex items-center justify-center rounded-lg text-xs font-semibold bg-blue-600 text-white shadow-sm">
            1
          </button>

          <button className="w-7 h-7 flex items-center justify-center rounded-lg text-xs font-semibold border border-slate-200 text-slate-600 bg-white hover:bg-slate-50 transition">
            2
          </button>

          <button className="p-1.5 border border-slate-200 rounded-lg text-slate-400 bg-white hover:bg-slate-50 transition">
            <FiChevronRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
